// Import from NPM
// -------------------------------------
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFeatures } from "flagged";
import { useSelector } from "react-redux";
import axios from "axios";

import { Input, Button } from "semantic-ui-react";

// Import from Config
// -------------------------------------
import { Div } from "@components/Generics.react";
import appConfig from "@config/app.config.json";

export default function TokenizerLogin(props) {
    const [username, setUsername] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [courseId, setCourseId] = useState("");
    const { baseUrl } = appConfig;
    const features = useFeatures();
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();

    useEffect(() => {
        const redirectPath = localStorage.getItem("redirectPath");
        if (redirectPath && redirectPath.includes("courses/")) {
            const courseMatch = redirectPath.match(/courses\/([a-zA-Z0-9]+)/);
            if (courseMatch) {
                setCourseId(courseMatch[1]);
            }
        }
    }, []);

    useEffect(() => {
        const redirectPath = localStorage.getItem("redirectPath");
        if (user && redirectPath) {
            localStorage.removeItem("redirectPath");
            navigate(redirectPath, { replace: true });
        }
    }, [user, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setMessage("");

        try {
            const formattedUsername = features.isEmailDomain && !username.includes("@unilever.com")
                ? `${username}@unilever.com`
                : username;

            const response = await axios.post(`${baseUrl}api/v3/users/email/check-user`, {
                username: formattedUsername,
                courseId,
            });

            if (response.data.exists) {
                setMessage("User is present and the email has been sent.");
                const redirectPath = localStorage.getItem("redirectPath");
                if (redirectPath) {
                    localStorage.removeItem("redirectPath");
                    setTimeout(() => {
                        navigate(redirectPath, { replace: true });
                    }, 20000);
                } else {
                    setTimeout(() => {
                        navigate("/dashboard", { replace: true });
                    }, 2000);
                }
            } else {
                setMessage("User not present");
            }
        } catch (error) {
            console.error("Error checking user:", error);
            setError("User not found. Please check and try again.");
        } finally {
            setLoading(false);
        }
    };
    // ========================= Render Function =================================
    return (
        <Div fluid white maxWd="400px" superpad rounded>
            <Div massive altText fluid center-align gutter>
                Generate Token
            </Div>
            {error && <Div padded fluid danger gutter>{error}</Div>}
            {message && (
                <Div
                    padded
                    fluid
                    gutter
                    style={{
                        backgroundColor: message === "User is present and the email has been sent." ? "#d4edda" : "#f8d7da",
                        color: message === "User is present and the email has been sent." ? "#155724" : "#721c24",
                        border: `1px solid ${message === "User is present and the email has been sent." ? "#c3e6cb" : "#f5c6cb"}`,
                        borderRadius: "4px",
                    }}
                >
                    {message}
                    {message === "User is present and the email has been sent." && (
                        <div style={{ marginTop: "8px", fontSize: "0.9em" }}>
                            Please check your inbox for the course link, it may take 1–2 minutes to arrive.
                        </div>
                    )}
                </Div>
            )}
            <Div fluid gutter>
                <form onSubmit={handleSubmit}>
                    <Input
                        fluid
                        type="text"
                        placeholder={features.isEmailDomain ? "Enter your email" : "Enter your email or email"}
                        value={username}
                        onChange={(e) => {
                            const value = features.isEmailDomain
                                ? e.target.value.replace("@unilever.com", "")
                                : e.target.value;
                            setUsername(value);
                        }}
                        required
                        label={features.isEmailDomain ? { basic: true, content: "@unilever.com" } : undefined}
                        labelPosition={features.isEmailDomain ? "right" : undefined}
                    />
                    <br />
                    <br />
                    <Button fluid primary type="submit" disabled={loading}>
                        {loading ? "Submitting..." : "Submit"}
                    </Button>
                    <Div bold gapTop>
                        Note : All the letters of your email ID should be in small letters.
                    </Div>
                </form>
            </Div>
        </Div>
    );
}
